//empty for future user actions
import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";


export const getCollections = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getCollections(), collection => {
            var collections = [];
            collection.forEach((doc) => {
                collections.push({ ...doc.data(), id: doc.id })
            });
            if (collections.length > 0) {
                dispatch({
                    type: actionTypes.GET_COLLECTION,
                    payload: {
                        collections: collections,
                        collectionEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_COLLECTION,
                    payload: {
                        collections: collections,
                        collectionEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}


export const selectCollection = (collectionObject) => async (dispatch) => {
    try {
        if (collectionObject) {
            localStorage.setItem("selectedCollection", JSON.stringify(collectionObject))
            dispatch({
                type: actionTypes.SELECT_COLLECTION,
                payload: collectionObject
            });
        }
    } catch (err) {
        console.error(err);
    }
};

export const getSelectedCollection = () => async (dispatch) => {
    try {
        var collectID = localStorage.getItem("selectedCollection") ? JSON.parse(localStorage.getItem("selectedCollection")) : false;
        if (collectID) {
            dispatch({
                type: actionTypes.SELECT_COLLECTION,
                payload: collectID
            });
        }
    } catch (err) {
        console.error(err);
    }
}